import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { DashboardComponent } from "./dashboard.component";
import { RouterModule } from "@angular/router";
import { OverviewModule } from "./overview/overview.module";
import { DetailsModule } from "./details/details.module";
import { AdvancedOverviewModule } from "./advanced/advanced-overview.module";
import { SharedModule } from "../shared/shared.module";

@NgModule({
    declarations: [DashboardComponent],
    imports: [
        CommonModule,
        AdvancedOverviewModule,
        OverviewModule,
        DetailsModule,
        RouterModule,
        SharedModule
    ],
})
export class DashboardModule {}
